import React from 'react'
import { Attachment } from '../../../components/media/attachment'
import { AudioButton } from '../../../components/media/audioButton'
import { Avatar } from '../../../components/avatar'
import { ButtonStyle, ButtonShape, Button } from '../../../components/simple/button'
import { DateWrapper } from '../../../components/simple/date'
import { TruncatedText } from '../../../components/simple/truncatedText'
import { IconWarningCircle, IconWhatsapp, IconText, IconReply } from '../../../icons/library'
import { MessageTags } from '../messageTags'
import { ReplyOption, ThreadConversationData } from './conversation'
import { AudioPlayer } from '../../../components/simple/audio'
import { MessageInfoLauncher } from '../../modals/messageinfo/messageInfo'
import { ConfirmReceiptPie } from '../message'

export const StandardConversation: React.FC<{
  data: ThreadConversationData
  showArchived: boolean
  setReplyOption: (replyOption: ReplyOption) => void
}> = ({ data, showArchived, setReplyOption }) => {
  return data.thread.map((m) => (
    <MessageInfoLauncher
      key={m.id}
      className="relative mx-2 flex flex-col border-b border-gray-200 p-2"
      messageID={m.id}
      canLaunch={m.canViewMessageInfo}
      cursor="cursor-pointer transition-colors duration-75 hover:bg-slate-50"
    >
      {m.archived && !showArchived ? (
        <div>Archived Message</div>
      ) : (
        <>
          <div className={`mb-2 flex items-center justify-between gap-2`}>
            {m.sendersPerspective && <DateWrapper date={m.date} detailed className="text-sm opacity-60" />}
            <div className="-m-1 flex gap-2 overflow-hidden p-1">
              <Avatar src={m.avatar!} size="sm" />
              <MessageTags
                tags={m.tags!}
                extras={
                  <>
                    {m.undeliveredInfo && (
                      <IconWarningCircle
                        opacity={0.5}
                        tooltip={<div dangerouslySetInnerHTML={{ __html: m.undeliveredInfo }} />}
                      />
                    )}
                    {m.sentAsWhatsApp && <IconWhatsapp opacity={0.3} tooltip="Sent through WhatsApp" />}
                    {m.sentAsText && <IconText opacity={0.3} tooltip="Sent as text" />}
                  </>
                }
              />
            </div>
            {!m.sendersPerspective && <DateWrapper date={m.date} detailed className="text-sm opacity-60" />}
          </div>
          <TruncatedText lines={4} opened={m === data.thread[data.thread.length - 1]}>
            <div style={{ wordWrap: 'break-word' }} dangerouslySetInnerHTML={{ __html: m.content }} />
          </TruncatedText>
          {m.attachments && m.attachments.length > 0 && (
            <div className="mt-2 flex gap-2">
              {m.attachments.map((a, i) => (
                <Attachment key={i} attachment={a} />
              ))}
            </div>
          )}
          {m.massRecordingURL && <AudioPlayer src={m.massRecordingURL} className="mt-2" />}
          <div className="absolute bottom-0 right-0 flex gap-1 p-2">
            {m.audioUrl && <AudioButton url={m.audioUrl} />}
            {m.confirmReceiptPie && (
              <ConfirmReceiptPie pie={m.confirmReceiptPie} messageID={m.id} canViewMessageInfo={m.canViewMessageInfo} />
            )}
            {m.directReply && (
              <Button
                buttonStyle={ButtonStyle.light}
                shape={ButtonShape.iconCircleSmall}
                onClick={() => {
                  setReplyOption(m.directReply!)
                }}
              >
                <IconReply />
              </Button>
            )}
          </div>
        </>
      )}
    </MessageInfoLauncher>
  ))
}
